import { z } from 'zod';
/** DTO для админ-UI: настройки DaData. Ключ не возвращается, только флаг set. */
export const integrationSettingsDtoSchema = z.object({
    dadataEnabled: z.boolean(),
    dadataApiKeySet: z.boolean(),
    dadataLastTestedAt: z.string().datetime().nullable(),
    dadataLastTestStatus: z.enum(['ok', 'failed']).nullable(),
    dadataLastTestError: z.string().nullable(),
    /** ЭДО.МИГ24: включена ли интеграция и задан ли токен (сам токен не отдаём). */
    edoEnabled: z.boolean(),
    edoTokenSet: z.boolean(),
    /** Превью токена (первые символы) и когда задан — чтобы видеть, что введён. */
    edoTokenHint: z.string().nullable(),
    edoTokenSetAt: z.string().datetime().nullable(),
    edoApiUrl: z.string().nullable(),
    /** Адрес веб-кабинета МИГ24 (боевой) — для ссылки на страницу подписания. */
    edoWebUrl: z.string().nullable(),
    /** Тестовая среда ЭДО: режим, адрес и задан ли тестовый токен. */
    edoTestMode: z.boolean(),
    edoTestApiUrl: z.string().nullable(),
    /** Адрес веб-кабинета МИГ24 (тестовый). */
    edoTestWebUrl: z.string().nullable(),
    edoTestTokenSet: z.boolean(),
    edoTestTokenHint: z.string().nullable(),
    edoTestTokenSetAt: z.string().datetime().nullable(),
    /** Интервал опроса событий ЭДО, секунды. */
    edoPollIntervalSec: z.number().int(),
    /** Базовый адрес сервиса визуализации XML→PDF (напр. https://xml2pdf.mig24.online). */
    pdfVizUrl: z.string().nullable(),
    updatedAt: z.string().datetime().nullable(),
});
/** Тело PUT /admin/integrations. */
export const integrationSettingsInputSchema = z.object({
    dadataEnabled: z.boolean(),
    /** null/undefined — не менять; '' — стереть; строка — поставить новый. */
    dadataApiKey: z.string().nullable().optional(),
    edoEnabled: z.boolean().optional(),
    /** Токен ЭДО (GUID). Те же правила: null — не менять, '' — стереть. */
    edoToken: z.string().nullable().optional(),
    /** Базовый URL API ЭДО. null/undefined — не менять; '' — стереть. */
    edoApiUrl: z.string().max(500).nullable().optional(),
    /** Адрес веб-кабинета МИГ24 (боевой). null — не менять; '' — стереть. */
    edoWebUrl: z.string().max(500).nullable().optional(),
    /** Тестовый режим ЭДО: обращения идут в тестовую среду. */
    edoTestMode: z.boolean().optional(),
    /** Базовый URL тестовой среды ЭДО. null — не менять; '' — стереть. */
    edoTestApiUrl: z.string().max(500).nullable().optional(),
    /** Адрес веб-кабинета МИГ24 (тестовый). null — не менять; '' — стереть. */
    edoTestWebUrl: z.string().max(500).nullable().optional(),
    /** Токен тестовой среды (GUID). null — не менять; '' — стереть. */
    edoTestToken: z.string().nullable().optional(),
    /** Интервал опроса событий ЭДО, секунды (мин. 10). */
    edoPollIntervalSec: z.number().int().min(10).max(86400).optional(),
    /** Адрес сервиса визуализации XML→PDF. null — не менять; '' — стереть. */
    pdfVizUrl: z.string().max(500).nullable().optional(),
});
/** Ответ DaData /suggest/party — нормализованный для нашего фронта. */
export const companySuggestionSchema = z.object({
    /** Что показываем в выпадашке: краткое наименование. */
    label: z.string(),
    /** Тип в нашей системе. */
    type: z.enum(['ENTREPRENEUR', 'LEGAL_RU', 'LEGAL_FOREIGN']),
    /** Полное наименование (с организационно-правовой формой). */
    fullName: z.string(),
    /** Краткое наименование. */
    shortName: z.string().nullable(),
    inn: z.string().nullable(),
    ogrn: z.string().nullable(),
    kpp: z.string().nullable(),
    /** Юридический адрес. */
    legalAddress: z.string().nullable(),
    /** ФИО руководителя (для ЮЛ) или ФИО ИП. */
    managerName: z.string().nullable(),
    /** Должность руководителя (для ЮЛ). */
    managerPost: z.string().nullable(),
});
/** Запрос/ответ публичного endpoint'а лукапа. */
export const lookupCompanyRequestSchema = z.object({
    query: z.string().min(2).max(200),
});
export const lookupCompanyResponseSchema = z.object({
    /** Если DaData отключена / не настроена — пустой массив (UI прячет автокомплит). */
    suggestions: z.array(companySuggestionSchema),
});
/** Тест-запрос — отправляет тестовый query, отдаёт ok/error. */
export const integrationsTestResponseSchema = z.object({
    ok: z.boolean(),
    error: z.string().nullable(),
});
/** Один абонент ЭДО, найденный по реквизитам (нормализовано для фронта). */
export const edoAbonentSchema = z.object({
    abonentCode: z.string(),
    name: z.string().nullable(),
    inn: z.string().nullable(),
    operatorName: z.string().nullable(),
});
/** Статус ответа ЭДО по поиску абонента. */
export const edoRequestStatusSchema = z.enum(['Unknown', 'Ok', 'NotFound', 'NotAllowed']);
/** Ответ поиска абонентов по ИНН: статус + плоский список. */
export const edoAbonentsResponseSchema = z.object({
    requestStatus: edoRequestStatusSchema,
    abonents: z.array(edoAbonentSchema),
});
/** Запрос поиска абонента ЭДО по ИНН (+опц. КПП). */
export const edoFindAbonentsQuerySchema = z.object({
    inn: z.string().trim().min(1).max(20),
    kpp: z.string().trim().max(20).optional(),
});
//# sourceMappingURL=integrations.js.map